import { useDoctorDeviceCached } from '@/common/hooks/useDoctorDeviceCached';
import useCustomize from '@/common/hooks/useCustomize';
import { hasDoctorIdentity } from '@/common/utils/doctorIdentity';
import { useUserInfoStore } from '@/modules/login/store/userInfo';

/** A doctor outside a partner site: the doctor's bottom nav (floating pill) is theirs on the mobile site too. */
export const useIsDoctorShell = () => {
  const user = useUserInfoStore(state => state.info);
  const partnerKey = useCustomize(state => state.customize.partnerKey);
  const deviceCached = useDoctorDeviceCached();
  return hasDoctorIdentity(user, deviceCached) && !partnerKey;
};

export default useIsDoctorShell;
